import { useSelector } from 'react-redux';
import type { RootState } from '../state';
import type { CmsControlledConfig, Config } from '../types/Config';

/**
 * @deprecated use `useCmsControlledConfig` instead:
 *   there is already _local_ per franchise config settings (some of which overlap)
 *   which is _also_ called "config", and _also_ has a type called `Config`
 */
export const useConfig = (
  compare?: (prev: Config, next: Config) => boolean,
): Config =>
  useSelector((state: RootState) => {
    const { config } = state;
    return {
      ...config,
      locales: config.locales || [],
      routes: config.routes || [],
    };
  }, compare);

export const useCmsControlledConfig = (
  compare?: (prev: CmsControlledConfig, next: CmsControlledConfig) => boolean,
): CmsControlledConfig =>
  useSelector((state: RootState) => {
    const { config } = state;
    return {
      ...config,
      locales: config.locales || [],
      routes: config.routes || [],
    };
  }, compare);
